import videojs from 'video.js';
import objectFitVideos from 'object-fit-videos';
import vars from '../globals';

function getGCD(a, b) {
	return b === 0 ? a : getGCD(b, a % b);
}

function getAspect(width, height) {
	let gcd = getGCD(width, height);

	return {
		width: width / gcd,
		height: height / gcd,
	};
}

function setVideoDimensions(video) {
	const windowAspect = getAspect(innerWidth, innerHeight);
	const videoAspect = getAspect(video.videoWidth, video.videoHeight);
	const windowValue = windowAspect.width / windowAspect.height;
	const videoValue = videoAspect.width / videoAspect.height;
	const permissibleValue = 0.25;

	if (Math.abs(windowValue - videoValue) < permissibleValue) {
		video.classList.add('is-cover');
	} else {
		video.classList.remove('is-cover');
	}
}

export const videoStart = (videos) => {
	videos.each((i, videoItem) => {
		const $step = $(videoItem).closest('.test__step');
		const $stepHeader = $step.find('.test__header');
		const $stepVariants = $step.find('.test__variants');
		const $videoContainer = $step.find('.test-video__container');
		const $playButton = $step.find('.test-video__play-button');
		const $skipButton = $step.find('.test-video__skip-button');

		let isPlayed = true;

		const video = videojs(videoItem, {
			controls: true,
			autoplay: false,
			muted: false,
			loop: false,
			playsinline: true,
			preload: 'auto',
		});

		video.src({
			src: $(videoItem).data('source'),
			type: 'video/mp4',
			withCredentials: false,
		});

		video.on('ended', () => {
			if (!$videoContainer.is(':visible')) {
				return;
			}

			$stepHeader.add($stepVariants).removeClass('is-hidden');

			$videoContainer
				.addClass('is-hidden')
				.trigger('test-show-question');
		});

		const videoTag = video.el().getElementsByTagName('video')[0];

		video.on('loadedmetadata', () => {
			setVideoDimensions(videoTag);
		});

		$playButton.on('click', () => {
			if (isPlayed) {
				video.pause();

				isPlayed = false;
			} else {
				video.play();

				isPlayed = true;
			}
		});

		$skipButton.on('click', () => {
			video.pause();

			$stepHeader.add($stepVariants).removeClass('is-hidden');

			$videoContainer
				.addClass('is-hidden')
				.trigger('test-show-question');
		});

		$step
			.on('test-step', (e, data) => {
				if ($step.data('number') === data) {
					if (!$videoContainer.data('object-fit')) {
						$videoContainer.data('object-fit', true);

						objectFitVideos(videoItem);
					}

					video.currentTime(0);
					video.play().catch((error) => error);
				}
			})
			.on('test-stop', () => {
				video.pause();
				video.currentTime(0);

				isPlayed = false;
			})
			.on('remove-video', () => {
				video.dispose();
			});

		let resizeTimeout = null;

		vars.$window.on('resize', () => {
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(() => {
				setVideoDimensions(videoTag);
			}, 500);
		});
	});
};

export default videoStart;
